import theme from "./theme"
import socket from "./socket"
import inputs from "./inputs"
export default {
    theme,
    socket,
    inputs,
    appName: "client",
}